<div class="container" id="organizationRiderProfile-container-main-{{organizationRiderDetail.organizationId}}">
  <div class="header-group" id="organizationRiderProfile-div-headerGroup">
    <h1 id="organizationRiderProfile-heading-organizationName-{{organizationRiderDetail.organizationId}}" [ngClass]="inEligibleRiderClass">
      {{organizationRiderDetail?.organizationName}} ({{organizationRiderDetail?.organizationCode}})
    </h1>
    <button
      mat-raised-button
      (click)="handleEditOrganizationRiderInfo()"
      *appRequiresPermissions="{any: ['organization_rider_update']}"
      id="organizationRiderProfile-button-edit-{{organizationRiderDetail.organizationId}}"
    >
      <mat-icon>edit</mat-icon>
      Edit
    </button>
  </div>

  <!-- Eligibility -->
  <div class="rides-info" id="organizationRiderProfile-div-ridesInfo">
    <mat-chip
      *ngIf="!organizationRiderDetail?.eligible"
      id="organizationRiderProfile-chip-rideIsIneligible-{{organizationRiderDetail.organizationId}}"
      class="ineligible"
    >
      Ineligible
    </mat-chip>
    <mat-slide-toggle
      [checked]="organizationRiderDetail?.eligible"
      (change)="handleEligibilityToggleClicked($event)"
      id="organizationRiderProfile-toggle-eligibility-{{organizationRiderDetail.organizationId}}"
      *appRequiresPermissions="{any: ['organization_rider_eligibility_update']}"
    ></mat-slide-toggle>
    <p id="organizationRiderProfile-text-eligibilityInfo-{{organizationRiderDetail.organizationId}}">
      Eligible for rides
      <span
        *ngIf="organizationRiderDetail.rideLimitDetail?.riderRidesRemaining !== null"
        id="organizationRiderProfile-span-remainingRides-{{organizationRiderDetail.organizationId}}"
      >
        | Remaining Rides: {{organizationRiderDetail.rideLimitDetail?.riderRidesRemaining}}
        ({{formatShortDate(organizationRiderDetail.rideLimitDetail?.riderRideLimitPeriodStartDate)}} -
        {{formatShortDate(organizationRiderDetail.rideLimitDetail?.riderRideLimitPeriodEndDate)}})
      </span>
    </p>
  </div>

  <div class="rider-info" id="organizationRiderProfile-div-riderInfo">
    <div class="first-colum" id="organizationRiderProfile-div-firstColumn">
      <!-- Profile Created -->
      <small id="organizationRiderProfile-label-profileCreated-{{organizationRiderDetail.organizationId}}">Profile Created</small>

      <p id="organizationRiderProfile-text-signedUp-{{organizationRiderDetail.organizationId}}">
        {{ organizationRiderDetail.createdDate | date: 'medium' }}
      </p>

      <!-- Name -->
      <small id="organizationRiderProfile-label-name">Name</small>
      <p id="organizationRiderProfile-text-name-{{organizationRiderDetail.organizationId}}" data-private>
        {{organizationRiderDetail.firstName + ' ' + organizationRiderDetail.lastName}}
      </p>

      <!-- Email Address -->
      <small id="organizationRiderProfile-label-email-{{organizationRiderDetail.organizationId}}">Email Address</small>

      <p id="organizationRiderProfile-text-email-{{organizationRiderDetail.organizationId}}" data-private>
        {{organizationRiderDetail.emailAddress ? organizationRiderDetail.emailAddress : 'Not set' }}
      </p>

      <!-- Phone Number -->
      <small id="organizationRiderProfile-label-phone-{{organizationRiderDetail.organizationId}}">Phone</small>
      <p id="organizationRiderProfile-text-phone-{{organizationRiderDetail.organizationId}}" data-private>
        {{organizationRiderDetail?.phoneNumber ? (organizationRiderDetail.phoneNumber | phone) : 'Not set'}}
      </p>
    </div>
    <div id="organizationRiderProfile-div-secondColumn">
      <ng-container *ngIf="organizationRiderDetail.riderOver18 !== null; else ageNotSet">
        <!-- Date of Birth -->
        <ng-container *appRequiresPermissions="{any: ['protected_organization_rider_read']}">
          <small id="organizationRiderProfile-label-dateOfBirth-{{organizationRiderDetail.organizationId}}">Date of Birth</small>

          <p id="organizationRiderProfile-text-dateOfBirth-{{organizationRiderDetail.organizationId}}" data-private>
            {{ getFormattedDateOfBirth(organizationRiderDetail?.dateOfBirth) }}
          </p>
        </ng-container>

        <!-- Age -->
        <small id="organizationRiderProfile-label-age-{{organizationRiderDetail.organizationId}}">Age</small>

        <p id="organizationRiderProfile-text-age-{{organizationRiderDetail.organizationId}}">
          <span *ngIf="!organizationRiderDetail.riderOver18" class="warning-text" id="organizationRiderProfile-span-minorWarning"
            >MINOR -
          </span>
          {{ organizationRiderDetail.age === null ? 'Over 18' : organizationRiderDetail.age + ' years old' }}
        </p>
      </ng-container>

      <ng-template #ageNotSet>
        <small id="organizationRiderProfile-label-dateOfBirth-{{organizationRiderDetail.organizationId}}">Age</small>
        <p id="organizationRiderProfile-text-ageNotSet-{{organizationRiderDetail.organizationId}}">Not set</p>
      </ng-template>

      <!-- Customer ID -->
      <small id="organizationRiderProfile-label-customerId-{{organizationRiderDetail.organizationId}}">Customer ID</small>
      <p id="organizationRiderProfile-text-customerId-{{organizationRiderDetail.organizationId}}" data-private>
        {{organizationRiderDetail.partnerIdentifier ? organizationRiderDetail.partnerIdentifier : 'Not set' }}
      </p>

      <!-- Service Level Preferences -->
      <small id="organizationRiderProfile-label-serviceLevelPreferences-{{organizationRiderDetail.organizationId}}"
        >Service Level Preferences</small
      >

      <p *ngFor="let organizationRiderServiceLevel of organizationRiderServiceLevels">
        <span
          [id]="'organizationRiderProfile-text-serviceLevel-'+ organizationRiderDetail.organizationId +'-' + organizationRiderServiceLevel.serviceLevel.code"
        >
          {{organizationRiderServiceLevel.serviceLevel.name}} {{organizationRiderServiceLevel.enabled ? "always" : "not always"}} allowed
        </span>
      </p>

      <!-- Rider Pool -->
      <ng-container *ngIf="shouldDisplayOrganizationRiderPoolInfo()">
        <small id="organizationRiderProfile-label-riderPool-{{organizationRiderDetail.organizationCode}}">Rider Pool</small>

        <p id="organizationRiderProfile-text-riderPool-{{organizationRiderDetail.organizationRiderPoolCode}}">
          {{ getOrganizationRiderPoolDisplayTextViaDetail() }}
        </p>
      </ng-container>
    </div>
  </div>
</div>
